import React, { useEffect, useState } from "react";
import MainContainer from "../../../layout/MainContainer";
import { Box, Button, IconButton, Tab, Tabs } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import IosSwitch from "../../../components/iosSwitch";
import CancelEventModal from "../../../Modals/cancelEvent";
import GenerateLink from "../../../Modals/generateLink";
import BookingHistory from "../../manageCustomers/bookingHistory";
import FilterMenu from "../../../components/filterMenu";
import {
  useCancelEventMutation,
  useChangeOfferStatusMutation,
  useExportOfferByIdMutation,
  useLazyGetOfferByIdQuery,
  useStopOfferBookingMutation,
} from "../../../service/offer";
import { showError, showToast } from "../../../constants/toasts";
import { Offer } from "../../../types/General";
import { CANCEL_TYPE, OFFER_TYPE } from "../../../utils/enums";
import Loader from "../../../constants/Loader";
import {
  formatDubaiDate,
  formatDubaiDateTime,
  formatDubaiTime,
} from "../../../utils/dateTime";
import { ConfirmationModal } from "../../../Modals/confirmationModal";
import { formatAEDNumber } from "../../../utils/validations";

enum STATUS {
  ACTIVE = 0,
  SCHEDULED = 1,
  EXPIRED = 2,
  ARCHIVED = 3,
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function PreviewOfferDetail() {
  const location = useLocation();
  const [getOfferDetail] = useLazyGetOfferByIdQuery();
  const [offerStatus] = useChangeOfferStatusMutation();
  const [cancelApi] = useCancelEventMutation();
  const [stopBooking] = useStopOfferBookingMutation();
  const [exportOfferById] = useExportOfferByIdMutation();

  const { id } = useParams();

  const { state } = location;
  const status = state?.status || "";
  const categoryTab = state?.categoryTab || "";
  const categoryId = state?.categoryId || "";
  const categoryName = state?.categoryName || "";
  const actionType = state?.actionType || "";
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  const offerType = state?.type || "EVENT";
  const [checked, setChecked] = useState(true);

  const [selectedReason, setSelectedReason] = useState("");
  const navigate = useNavigate();
  const goBack = () => {
    if (!status && !categoryTab && !categoryTab && !categoryName) {
      navigate(-1);
      return;
    }
    navigate("/manage-offer", {
      state: { status, categoryTab, categoryId, categoryName },
    });
  };
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [offerData, setOfferData] = useState<Offer | null>(null);
  const [loading, setLoading] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openStopBooking, setOpenStopBooking] = useState(false);

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(`?tab=${newValue}`, { replace: true });
    setValue(newValue);
  };

  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const groupOptions = [
    { label: "Field 1", value: "10" },
    { label: "Field 2", value: "20" },
    { label: "Field 3", value: "30" },
    { label: "Field 4", value: "40" },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const filteredOptions = groupOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGroupChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedGroups(typeof value === "string" ? value.split(",") : value);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const getOfferDetailApi = async () => {
    try {
      setLoading(true);
      const response = await getOfferDetail({
        offerId: id,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setOfferData(response?.data);
        setChecked(response?.data?.isActive || false);
      } else {
        setLoading(false);
        setOfferData(null);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const cancelEventApi = async () => {
    try {
      const response = await cancelApi({
        offerId: id,
        CancelType: "Cancelled",
      }).unwrap();

      if (response.status === 200) {
        showToast(response?.message || "");
        setOpenModal(false);
        getOfferDetailApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const stopBookingApi = async () => {
    try {
      const response = await stopBooking({
        offerId: id,
      }).unwrap();

      if (response.status === 200) {
        showToast(response?.message || "");
        setOpenModal(false);
        getOfferDetailApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeStatusApi = async () => {
    try {
      const response = await offerStatus({
        offerId: id,
      }).unwrap();

      if (response.status === 200) {
        getOfferDetailApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const exportOfferByIdApi = async () => {
    try {
      setLoading(true);
      const response: any = await exportOfferById({
        format: "excel",
        offerId: id,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        window.open(response?.downloadUrl, "_blank");
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (tab) {
      setValue(Number(tab));
    }
  }, [tab]);

  useEffect(() => {
    getOfferDetailApi();
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              View Offer
            </h1>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={exportOfferByIdApi}>
              <DownloadIcon /> Export
            </Button>
          </div>
        </div>
        <div className="cards view_page prvw_ofr prvw_ofr_detail">
          <h2>Image Upload</h2>
          <ul className="imgs_mn">
            {offerData?.offerImages?.map((item) => (
              <li key={item?.id}>
                <figure>
                  <img src={item?.offerImageUrl} alt="icon" />
                </figure>
              </li>
            ))}
          </ul>
          <Box
            className="custom_tabs2 offer_manage_tab mt_40 mb_30"
            sx={{ width: "100%" }}
          >
            <Tabs
              className="custom_tabs_links"
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label={offerData?.category?.name} {...a11yProps(0)} />
              {actionType === "scheduled" ||
              state?.status === STATUS.ARCHIVED ? null : (
                <Tab label="Booking History" {...a11yProps(1)} />
              )}
            </Tabs>
            <div className="btn_flex">
              {state?.status === STATUS.ARCHIVED ? null : (
                <IosSwitch
                  checked={checked}
                  setChecked={setChecked}
                  onStatusChange={changeStatusApi}
                />
              )}

              {offerData?.cancelType === CANCEL_TYPE.REFUND ? (
                <Button className="btn btn_grey">Refund Initiated</Button>
              ) : offerData?.cancelType === CANCEL_TYPE.COMPENSATION ? (
                <Button className="btn btn_grey">Compensated</Button>
              ) : offerData?.cancelType === CANCEL_TYPE.CANCELLED ? (
                <Button className="btn btn_grey">Cancelled</Button>
              ) : null}
              {offerData?.offerType === OFFER_TYPE.EVENTS &&
              !offerData?.isCancelOffer &&
              state?.status === STATUS.ACTIVE ? (
                <>
                  <Button
                    className="btn btn_danger"
                    onClick={() => {
                      if (
                        offerData?.eventType === "Paid" &&
                        offerData?.totalNumberofBooking > 0
                      ) {
                        setOpenModal(true);
                      } else {
                        setOpenCancel(true);
                      }
                    }}
                  >
                    Cancel Event
                  </Button>
                </>
              ) : (
                <></>
              )}

              {offerData?.offerType === OFFER_TYPE.EVENTS &&
              state?.status === STATUS.ACTIVE &&
              !offerData?.isCancelOffer ? (
                <Button
                  className="btn btn_danger"
                  onClick={() => {
                    setOpenStopBooking(true);
                  }}
                >
                  {offerData?.isBookingStop ? "Start Booking" : "Stop Booking"}
                </Button>
              ) : null}

              <FilterMenu
                startDate={null}
                endDate={null}
                setStartDate={() => {}}
                setEndDate={() => {}}
              />
              <Button
                className="btn btn_primary"
                onClick={() =>
                  navigate(`/manage-offer/build-offer/edit/${id}`, {
                    state: {
                      status: status,
                      actionType: actionType,
                      categoryTab: categoryTab,
                      categoryId: categoryId,
                      categoryName: categoryName,
                    },
                  })
                }
              >
                {" "}
                <img src="/static/images/edit_icon.svg" alt="icon" /> Edit
                Details
              </Button>

              {state?.status === STATUS.ARCHIVED ||
              state?.status === STATUS.EXPIRED ? null : (
                <Button
                  className="btn btn_grey"
                  onClick={() =>
                    navigate(
                      `/manage-offer/preview-offer-detail/add-user?offerType=${offerData?.offerType}`,
                      {
                        state: {
                          offerId: offerData?.id,
                          isCancellationPolicy: offerData?.isCancellationPolicy,
                          questions: offerData?.questions,
                          offerStartDate: offerData?.offerStartDate,
                          offerEndDate: offerData?.offerEndDate,
                          numberOfGuest: offerData?.numberOfGuest,
                          eventType: offerData?.eventType,
                          price: offerData?.memberPrice,
                          isGuestAdded: offerData?.isGuestAdded,
                          isdiningforOther: offerData?.isdiningforOther,
                          advanceBookingPeriod: offerData?.advanceBookingPeriod,
                        },
                      }
                    )
                  }
                >
                  {" "}
                  Add User
                </Button>
              )}
            </div>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <div className="section_title">
              <div className="lt">
                <h2>
                  {offerData?.title || "-"}{" "}
                  <span style={{ color: "red" }}>
                    {offerData?.isCancelOffer ? "(Cancelled)" : ""}
                  </span>
                </h2>
              </div>
            </div>
            <div className="rstrnt_flx">
              <div className="rstrnt_lst">
                <p>Offer Type</p>
                <h3>{offerData?.offerType || "-"}</h3>
              </div>

              <div className="rstrnt_lst">
                <p>Location</p>
                <h3>{offerData?.badge || "-"}</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Subtitle</p>
                <h3>{offerData?.subtitle || "-"}</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Groups</p>
                <h3>
                  {offerData?.offerGroups?.length
                    ? offerData?.offerGroups?.map((g) => g.name).join(" , ")
                    : "-"}
                </h3>
              </div>
              <div className="rstrnt_lst">
                <p>Tag</p>
                <h3>
                  {offerData?.offerTags?.length
                    ? offerData?.offerTags?.map((g) => g.name).join(" , ")
                    : "-"}
                </h3>
              </div>
              <div className="rstrnt_lst">
                <p>Offer Display Start Period</p>
                <h3>
                  {offerData?.offerStartDate
                    ? formatDubaiDateTime(offerData?.offerStartDate)
                    : "-"}
                </h3>
              </div>
              <div className="rstrnt_lst">
                <p>Offer Display End Period</p>
                <h3>
                  {" "}
                  {offerData?.offerEndDate
                    ? formatDubaiDateTime(offerData?.offerEndDate)
                    : "-"}
                </h3>
              </div>
              {offerType !== "EXPERIENCE" && offerType !== "EVENT" && (
                <div className="rstrnt_lst">
                  <p>Advance Booking Period</p>
                  <h3>{offerData?.advanceBookingPeriod || "-"}</h3>
                </div>
              )}

              {offerData?.offerType === "EXPERIENCE" ? (
                <>
                  <div className="rstrnt_lst">
                    <p>End Date</p>
                    <h3>12-06-2025</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>End Time</p>
                    <h3>12:00 PM</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Whats App Number</p>
                    <h3>+91 98765246</h3>
                  </div>
                </>
              ) : offerData?.offerType === "Events" ? (
                <>
                  <div className="rstrnt_lst">
                    <p>Type</p>
                    <h3>{offerData?.eventType || "-"}</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Member Price</p>
                    <h3>
                      AED{" "}
                      {offerData?.memberPrice
                        ? formatAEDNumber(offerData?.memberPrice)
                        : "0"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Non-Member Price</p>
                    <h3>
                      AED{" "}
                      {offerData?.noMemberPrice
                        ? formatAEDNumber(offerData?.noMemberPrice)
                        : "0"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Event Date</p>
                    <h3>
                      {offerData?.eventDateTime
                        ? formatDubaiDate(offerData?.eventDateTime)
                        : "-"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Event Time</p>
                    <h3>
                      {" "}
                      {offerData?.eventDateTime
                        ? formatDubaiTime(offerData?.eventDateTime)
                        : "-"}
                    </h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>No. Of. Guests allowed with a Member</p>
                    <h3>{offerData?.numberOfGuest || "0"}</h3>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="btrfly_eft_mn">
              <div className="btrfly_eft_lft">
                <div className="btrfly_eft control_group w_50">
                  <label>Butterfly Effect</label>
                  <IosSwitchMain
                    checked={offerData?.isButterflyEffect ? true : false}
                    disabled={true}
                  />
                </div>
                <div className="effts_dscrptn">
                  <p>Description</p>
                  <h3>
                    {offerData?.description ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: offerData?.description,
                        }}
                      />
                    ) : (
                      <p>-</p>
                    )}
                  </h3>
                </div>
                {offerData?.isCancellationPolicy ? (
                  <div className="cncltn_plcy">
                    <h2>Cancellation Policy</h2>
                    <div className="effts_dscrptn">
                      <p>
                        Cancellation Amount
                        {/* <span>
                        <img src="/static/images/edit_icon.svg" />
                      </span> */}
                      </p>
                      <h3>{`${offerData?.cancellationAmountPerPerson || "0"} AED`}</h3>
                    </div>
                    <div className="effts_dscrptn">
                      <p>
                        Cancellation Hours
                        {/* <span>
                        <img src="/static/images/edit_icon.svg" />
                      </span> */}
                      </p>
                      <h3>{`${offerData?.cancellationHours || "0"} Hours`}</h3>
                    </div>
                  </div>
                ) : null}
              </div>
              {offerData?.isButterflyEffect === true ? (
                <div className="btrfly_eft_ryt">
                  <figure>
                    <img
                      src={offerData?.offerImages[0]?.offerImageUrl}
                      alt=""
                    />
                  </figure>
                  <div className="btrfly_eft_rytcnt">
                    <span>
                      {offerData?.offerType === OFFER_TYPE.CONTACT_DEALERS
                        ? "Experience"
                        : offerData?.offerType === OFFER_TYPE.EVENTS
                          ? "Events"
                          : "Dining"}
                    </span>
                    <h3>{offerData?.title || "-"}</h3>
                    <p>{offerData?.subtitle || "-"}</p>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="control_group w_100 prfrnc">
              {offerData?.questions?.length ? (
                <div style={{ marginTop: "10px" }}>
                  <h2 style={{ marginBottom: "20px" }}>Saved Questions</h2>
                  {offerData?.questions?.map((q, idx) => (
                    <div key={idx} style={{ marginBottom: 10 }}>
                      <strong
                        style={{ fontSize: "16px" }}
                      >{`${idx + 1}. ${q?.label}`}</strong>{" "}
                      ({q?.inputType})
                      {q?.inputType === "Radio" ||
                      q?.inputType === "Checkbox" ? (
                        <ul style={{ marginTop: 10 }}>
                          {q?.options?.map((opt, i) => {
                            return (
                              <li
                                style={{
                                  color: "white",
                                  listStyleType: "none",
                                }}
                                key={i}
                              >
                                {`Option ${i + 1} - ${opt?.optionText}`}
                              </li>
                            );
                          })}
                        </ul>
                      ) : null}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <BookingHistory
              hidePast={true}
              offerId={id}
              actionType={actionType}
            />
          </CustomTabPanel>
        </div>
      </MainContainer>

      <CancelEventModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpen={setOpenModal}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        getOfferDetailApi={getOfferDetailApi}
        offerId={id}
      />

      <ConfirmationModal
        text={"Are you sure to cancel this event?"}
        openModal={openCancel}
        setOpenModal={setOpenCancel}
        handleSubmit={cancelEventApi}
      />

      <ConfirmationModal
        text={
          offerData?.isBookingStop
            ? "Are you sure to start booking?"
            : "Are you sure to stop booking?"
        }
        openModal={openStopBooking}
        setOpenModal={setOpenStopBooking}
        handleSubmit={stopBookingApi}
      />

      <GenerateLink
        open={openModal2}
        onClose={() => setOpenModal2(false)}
        setOpen={setOpenModal2}
        type="offerManagement"
        loading={false}
        setLoading={() => {}}
      />
    </>
  );
}

export default PreviewOfferDetail;
